(() => {
  if (window.AOWVat) return;
  const textRecords = new WeakMap();
  const key = 'aow-vat-display';
  const moneyPattern = /£\s*((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)/g;
  const selectors = [
    '[data-aow-product-price] .price-item', '[data-aow-custom-price]', '[data-aow-custom-unit]',
    '[data-aow-variant-main-price]', '[data-aow-variant-unit-price]', '.variant-unit-price',
    '[data-aow-selected-price]', '[data-aow-selected-unit-price]',
    '[data-aow-quick-add-variant-main]', '[data-aow-quick-add-variant-unit]', '.aow-quick-add__variant-unit',
    '[data-aow-quick-add-overlay] .aow-quick-add__volume-pricing strong',
    '[data-aow-cart-item] .cart-item__price-wrapper', '[data-aow-cart-unit-display]',
    '.aow-trade-cart-unit-price', '[data-aow-cart-item] .cart-item__mobile-total strong',
    '[data-aow-cart-item] [data-aow-cart-unit-wrapper]', '[data-aow-cart-total]',
    '.cart-item .unit-price', '.cart-item .product-option',
    '[data-fast-price]', '[data-fast-variant] option',
    '[data-price-display]', '[data-unit-price-display]', '[data-trade-price-display]', '[data-trade-unit-price-display]',
    '[data-detail-price]', '[data-detail-unit-price]', '[data-detail-trade-price]', '[data-detail-trade-unit-price]',
    '[class*="ai-plant-slider__product-price-"]', '[class*="ai-deals-scroller__price-"]',
    '[class*="ai-deals-scroller__compare-price-"]', '[class*="ai-featured-products__price-"]',
    '[class*="ai-membership-app-price-"] strong', '[class*="ai-bulk-buy-product-price-"]', '[class*="ai-bulk-buy-total-"]',
    '[class*="ai-cart-item-pricing-"]', '[class*="ai-cart-item-line-total-value-"]',
    '.aow-market__price', '.aow-market__board-price', '[data-aow-price]', '[data-aow-pulse-price]',
    '.per-unit-price', '[data-price-per-stem]', '.price-per-item', 'price-per-item .price',
    '.quick-order-list__total .totals__total-value', '.quick-order-list__table .price',
    '.quick-order-list__table .product-option', '.volume-pricing li span:last-child'
  ].join(',');
  const excluded = 'script,style,textarea,input,[data-aow-vat-ignore],.order-history,.order-details';
  const formatter = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let config;
  let mode = 'exclusive';
  let queued = false;
  let observer;

  function readMode() {
    try { return localStorage.getItem(key) || localStorage.getItem('vatStatus') || 'exclusive'; }
    catch (_) { return 'exclusive'; }
  }

  function sourceText(node) {
    let record = textRecords.get(node);
    if (!record && node.parentElement?.dataset.aowVatText) {
      try {
        const index = Array.prototype.indexOf.call(node.parentNode.childNodes, node);
        record = JSON.parse(node.parentElement.dataset.aowVatText)[index];
      } catch (_) {}
    }
    return record && node.nodeValue === record.rendered ? record.base : node.nodeValue;
  }

  function baseText(element) {
    if (!element) return '';
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let text = '';
    while (walker.nextNode()) text += sourceText(walker.currentNode);
    return text;
  }

  function taxFactor(element) {
    if (config.exempt) return 1;
    if (element.closest('[data-aow-vat-taxable]')?.dataset.aowVatTaxable === 'false') return 1;
    const total = element.closest('[data-aow-vat-items]');
    if (total) {
      try {
        const items = JSON.parse(total.dataset.aowVatItems);
        const field = window.AOWTradePricing?.isTrade() ? 'original' : 'final';
        const all = items.reduce((sum, item) => sum + Number(item[field]), 0);
        const taxable = items.reduce((sum, item) => sum + (item.taxable ? Number(item[field]) : 0), 0);
        return all > 0 ? 1 + config.rate * taxable / all : 1;
      } catch (_) { return 1; }
    }
    return 1 + config.rate;
  }

  function renderText(node) {
    const element = node.parentElement;
    if (!element || element.closest(excluded)) return;
    const base = sourceText(node);
    if (!base || !base.includes('£')) return;
    const factor = taxFactor(element);
    const label = config.exempt ? config.exemptLabel : factor === 1 ? config.none : mode === 'inclusive' ? config.inc : config.ex;
    const multiplier = config.taxesIncluded ? (mode === 'inclusive' ? 1 : 1 / factor) : (mode === 'inclusive' ? factor : 1);
    const rendered = base.replace(moneyPattern, (_, amount) => {
      const cents = Math.round(Number(amount.replaceAll(',', '')) * 100 * multiplier);
      return '£' + formatter.format(cents / 100) + '\u00a0' + label;
    });
    textRecords.set(node, { base, rendered });
    const index = Array.prototype.indexOf.call(element.childNodes, node);
    let records = {};
    try { records = JSON.parse(element.dataset.aowVatText || '{}'); } catch (_) {}
    records[index] = { base, rendered };
    element.dataset.aowVatText = JSON.stringify(records);
    if (node.nodeValue !== rendered) node.nodeValue = rendered;
    element.dataset.aowVatPrice = '';
  }

  function apply() {
    if (!config) return;
    const seen = new Set();
    document.querySelectorAll(selectors).forEach(element => {
      if (element.closest(excluded)) return;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!seen.has(node)) { seen.add(node); renderText(node); }
      }
    });
    document.querySelectorAll('[data-aow-vat-mode]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.aowVatMode === mode));
    });
    document.querySelectorAll('.tax-note, .product__tax').forEach(element => {
      const text = mode === 'inclusive' ? config.noteInc : config.noteEx;
      if (element.textContent !== text) element.textContent = text;
    });
    document.documentElement.dataset.aowVatMode = mode;
  }

  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  }

  function setMode(value, announce = true) {
    mode = value === 'inclusive' ? 'inclusive' : 'exclusive';
    try { localStorage.setItem(key, mode); } catch (_) {}
    apply();
    if (announce) {
      const status = document.querySelector('[data-aow-vat-status]');
      if (status) status.textContent = mode === 'inclusive' ? config.statusInc : config.statusEx;
    }
    document.dispatchEvent(new CustomEvent('aow:vat-changed', { detail: { mode } }));
  }

  function start() {
    const data = document.getElementById('aow-vat-config');
    if (!data) return;
    config = JSON.parse(data.textContent);
    mode = readMode() === 'inclusive' ? 'inclusive' : 'exclusive';
    document.querySelectorAll('[data-aow-vat-mode]').forEach(button => {
      button.addEventListener('click', () => setMode(button.dataset.aowVatMode));
    });
    apply();
    document.querySelectorAll('[data-aow-vat-control]').forEach(control => { control.hidden = false; });
    observer = new MutationObserver(records => {
      if (records.some(record => {
        if (record.type !== 'characterData') return true;
        return textRecords.get(record.target)?.rendered !== record.target.nodeValue;
      })) refresh();
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-aow-vat-taxable', 'data-aow-vat-items'] });
    document.addEventListener('aow:trade-pricing-ready', refresh);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('storage', event => { if (event.key === key) setMode(event.newValue, false); });
  }

  window.AOWVat = { refresh, baseText, setMode, mode: () => mode };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
